import axios from '../utils/axios';

export default function fetchInactiveRecruiterDashboard(adminId, params) {
    return axios.get(`/admin/${adminId}/get-inactive-recruiters`, {
        params,
        responseType: 'blob'
    });
}
